module.exports = __webpack_public_path__ + "img/focada.a83fe099.png";